import React from 'react';
import styles from './StickyNavbar.module.scss';
import { useNavigate } from 'react-router-dom'; 

interface StickyNavbarProps {
  activeSection: "form" | "offers";
  onScrollToSection: (section: "form" | "offers") => void;
  onInscribirmeClick?: () => void;
  logo: string;
  totalOffers?: number;
}

const StickyNavbar: React.FC<StickyNavbarProps> = ({
  activeSection,
  onScrollToSection,
  onInscribirmeClick,
  logo,
  totalOffers = 0,
}) => {
  const navigate = useNavigate();

  return (
    <nav className={styles.stickyNavbar}>
      <div className={styles.stickyNavbar_content}>
        <div className={styles.stickyNavbar_logoContainer}>
          <img
            onClick={() => navigate("/")}
            src={logo || "/placeholder.svg"}
            alt="Logo de Edify"
            className={styles.stickyNavbar_logo}
          />
        </div>

        <div className={styles.stickyNavbar_tabs}>
          <button
            className={`${styles.stickyNavbar_tab} ${activeSection === "form" ? styles.active : ""}`}
            onClick={() => onInscribirmeClick?.() ?? onScrollToSection("form")}
          >
            Inscribirme
          </button>
        </div>
      </div>
    </nav>
  );
};

export default StickyNavbar;
